import React from "react";
import {connect} from "react-redux";

import {withStyles} from "@material-ui/core/styles";

import styles from "./styles";
import CheckboxFormElement from "../../formElement/CheckboxFormElement";
import {isRequiredQuestion} from "../../../../../utils";
import {FIELD_REQUIRED_MSG} from "../../../../../constants";

function isCheckboxQuestionValid(question, step, afterChange, service) {
  let isValid = true
  if (isRequiredQuestion(question)) {
    if (question.answer !== true) {
      isValid = false
      question.error = FIELD_REQUIRED_MSG;
    } else {
      question.error = null
    }
  }
  return isValid
}

function checkboxQuestionAnswer(question){
  return {
    question_uid: question.uid,
    answer: [question.answer || false] // if no answer provided - set as false
  }
}

const mapStateToProps = (state) => ({
  investmentPlatform: state.get('investmentPlatform').toJS()
});

export const CheckboxQuestionMethods = {
  required: isRequiredQuestion,
  valid: isCheckboxQuestionValid,
  answer: checkboxQuestionAnswer,
}

const CheckboxQuestion = props => {
  const {
    classes,
    question,
    onAnswerChange,
    disabled,
    custom_classes,
    dataService,
  } = props;

  const label = question.question_text || '';
  const helpText = question.info;
  const required = CheckboxQuestionMethods.required(question) || question.required_check;

  const handleChange = (newValue) => {
    question.error = null;  // clean error
    onAnswerChange(question.uid, newValue);
  };

  return (
    <div>
      <CheckboxFormElement
        disabled={disabled || false}
        value={question.answer || false}
        label={label}
        name={question.uid}
        onChange={handleChange}
        required={required}
        custom_classes={custom_classes}
        error={question.error}
        helpTextUsed={!!helpText}
      />
      {helpText && <div className={classes.helpText}>{helpText}</div>}
    </div>
  );
};

export default connect(mapStateToProps)(withStyles(styles)(CheckboxQuestion));